import { useFetchData } from "../../../hooks/useFetch";
import useUpload from "../../../hooks/useUpload";
import { User } from "../../../models/response/user/user";

import { API_OAUTH_ROUTER, API_UPLOAD_ROUTER, API_PUBLIC_ROUTER } from "../../../services/api-config";



export const AuthService = {
    postLogin: () => {
        const { request, baseResponse, loading } = useFetchData.Post<User>();
        return {
            fetch: (data: { username: string; password: string }) => request({
                endPoint: API_OAUTH_ROUTER.API_LOGIN,
                data: data
            }),
            response: baseResponse,
            loading: loading
        };
    },

    postLoginVerify: () => {
        const { request, baseResponse, loading } = useFetchData.Post<User>();
        return {
            fetch: (data: { username: string; password: string; device_uuid: string; otp: string }) => request({
                endPoint: API_OAUTH_ROUTER.VERIFY_OTP_LOGIN,
                data: data
            }),
            response: baseResponse,
            loading: loading
        };
    },

    postVerifyForgotPassword: () => {
        const { request, baseResponse, loading } = useFetchData.Post<any>();
        return {
            fetch: (data: { username: string; otp: string }) => request({
                endPoint: API_OAUTH_ROUTER.VERIFY_OTP_FORGOT_PASSWORD,
                data: data
            }),
            response: baseResponse,
            loading: loading
        };
    },

    postForgotPassword: () => {
        const { request, baseResponse, loading } = useFetchData.Post();
        return {
            fetch: (data: { username: string; token: string; new_password: string }) => request({
                endPoint: API_OAUTH_ROUTER.FORGOT_FORGOT_PASSWORD,
                data: data
            }),
            response: baseResponse,
            loading: loading
        };
    },

    postLogout: () => {
        const { request, baseResponse, loading } = useFetchData.Post({ showScreenLoading: true });
        return {
            // push_token: gỡ ĐÚNG thiết bị đang đăng xuất — các máy khác của cùng tài khoản vẫn nhận thông báo.
            fetch: (data?: { push_token?: string }) => request({
                endPoint: API_OAUTH_ROUTER.API_LOGOUT,
                data: data ?? {},
            }),
            response: baseResponse,
            loading: loading
        };
    },
}

export const MediaService = {
    Upload: () => {
        const { uploadFiles, baseResponse, isUploading, uploadProgress } = useUpload<any>(API_UPLOAD_ROUTER.API_UPLOAD);
        return { uploadFiles, baseResponse, isUploading, uploadProgress };
    },
}

export const PublicService = {
    setting: () => {
        const { request, baseResponse, loading } = useFetchData.Get<any>();
        return {
            fetch: () => request({
                endPoint: API_PUBLIC_ROUTER.API_SETTING,
            }),
            response: baseResponse,
            loading: loading
        };
    }
}